// import { API_POST, DBRequest, useConfig } from '../../api/api';
import { useTranslation } from 'react-i18next';
import ExoStepper, { FinalPage } from '../../../../components/exo/ExoStepper';
import StepDelivery from '../../../../components/steps/StepDelivery';
import ExoDialog from '../../../../components/exo/ExoDialog';
import { API_PATCH, DBRequest, useConfig } from '../../../../api/api';
import { useEffect, useState } from 'react';
import StepCustomStartUp from '../../../../components/steps/StepCustomStartUp';
import { first } from 'lodash-es';

const EditContract = ({
  open,
  onClose,
  contract,
  onUpdate,
  employeeId,
  debug = false,
  employeeInfo,
}) => {
  const { t } = useTranslation();
  const [steps, setSteps] = useState([]);

  // create steps based on contract vars
  //Helper to clean identifier
  const cleanIdentifier = (identifier) => identifier.replace(/^%%|%%$/g, '');

  useEffect(() => {
    if (!contract) return;
    // Map contract vars to form fields
    const fields = contract.vars.map((v) => ({
      label: t(v.displayName),
      type: v.type,
      key: cleanIdentifier(v.identifier),

      ...(v.type === 'customSelect' || v.type === 'customMultiSelect'
        ? {
            options:
              v.options?.map((opt) => ({
                label: opt.label,
                value: opt.value,
              })) || [],
            noUnselect: true,
          }
        : {}),
    }));

    setSteps([
      {
        label: t('Contract Info'),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
          activeStep,
          setActiveStep,
        }) => (
          <StepCustomStartUp
            fields={fields}
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
          />
        ),
      },
      {
        label: t('Delivery'),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepDelivery
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            recipientKey="user"
          />
        ),
      },
    ]);
  }, [contract]);

  const config = useConfig();
  const finalStep = {
    operation: ({
      dataCollection,
      handleResponse,
      setIsLoading,
      handleError,
    }) => {
      // Map form data back to contract vars
      const varsObject = contract?.vars.reduce((acc, v) => {
        const key = cleanIdentifier(v.identifier);

        if (!(key in dataCollection)) return acc;

        let value = dataCollection[key];

        acc[v.id] = value;
        return acc;
      }, {});

      const payload = {
        user: { id: employeeId },
        preset: { id: contract.contractPresetId },
        delivery: {
          ...dataCollection?.delivery,
        },
        vars: varsObject,
      };

      setIsLoading(true);
      DBRequest({
        config,
        path: `employee-contracts/${contract.id}`,
        method: API_PATCH(payload),
        onResponse: (data) => {
          onUpdate(data);
          onClose();
        },
        onLoading: setIsLoading,
        onError: handleError,
      });
    }, // your operation with the data
    content: (response) => <FinalPage response={response} />, // component with final operations and the feedback
  };

  // Prepare initial form data based on contract vars
  const startData = {
    ...(contract?.vars.reduce((acc, v) => {
      const key = cleanIdentifier(v.identifier);

      let value = v.value ?? v.defaultValue;

      if (v.type === 'customMultiSelect') {
        value = contract.daysInWeek;
      }

      acc[key] = value;
      return acc;
    }, {}) || {}),
    user: {
      emails: employeeInfo?.email
        ? [
            {
              emailAddress: employeeInfo.email,
            },
          ]
        : [],
      firstName: employeeInfo?.firstName,
      lastName: employeeInfo?.lastName,
      salutation: employeeInfo?.salutation,
    },
  };

  return (
    <ExoDialog open={open} onClose={onClose}>
      <ExoStepper
        label={t('Edit Contract')}
        draftType={'work-contract'}
        onClose={onClose}
        data={steps}
        finalStep={finalStep}
        startDataCollection={startData}
        //previewDocument="employee_contract"
        noRecipientType
        debug={debug}
      />
    </ExoDialog>
  );
};

export default EditContract;
